import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { PlayerBar } from "@/components/PlayerBar";
import { CookieBanner, Footer } from "@/components/Chrome";
import Home from "@/pages/Home";
import Charts from "@/pages/Charts";
import ArtistPage from "@/pages/ArtistPage";
import TrackPage from "@/pages/TrackPage";
import Pricing from "@/pages/Pricing";
import Login, { AuthCallback } from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import PrivacySettings from "@/pages/PrivacySettings";
import Legal from "@/pages/Legal";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import CollectionPage from "@/pages/CollectionPage";
import { AddToPlaylistDialog } from "@/components/Collections";

const RequireAuth = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <div className="h-64 rounded-3xl bg-white/5 animate-pulse" />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/charts" element={<Charts />} />
      <Route path="/artist/:slug" element={<ArtistPage />} />
      <Route path="/track/:id" element={<TrackPage />} />
      <Route path="/album/:id" element={<CollectionPage kind="album" />} />
      <Route path="/playlist/:id" element={<CollectionPage kind="playlist" />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admin" element={<RequireAuth admin><Admin /></RequireAuth>} />
      <Route path="/settings/privacy" element={<RequireAuth><PrivacySettings /></RequireAuth>} />
      <Route path="/terms-of-service" element={<Legal doc="terms" />} />
      <Route path="/privacy-policy" element={<Legal doc="privacy" />} />
      <Route path="/legal-notices" element={<Legal doc="legal" />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="*" element={<div className="py-24 text-center text-zinc-400">Page not found</div>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <div className="hub-glow-bg min-h-screen pb-28">
            <Navbar />
            <main className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-10 pt-8 relative z-[2]"><AppRouter /></main>
            <Footer />
          </div>
          <PlayerBar />
          <CookieBanner />
          <AddToPlaylistDialog />
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
